module.exports = __webpack_public_path__ + "static/img/ai-introduce.5f6a0ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ai-introduce.png
// module id = EuXR
// module chunks = 0